(function($) {
    "use strict";

      jQuery(document).ready(function(){
    
    
    /*--------------------------
     ScrollUp
    ---------------------------- */
    $.scrollUp({
        scrollText: '<i class="fa fa-angle-double-up"></i>',
        easingType: 'linear',
        scrollSpeed: 900,
        animation: 'fade'
    });
    

    /*-----
    jQuery MeanMenu
    ------------------------------ */
    $('.mobile-menu nav').meanmenu({
        meanScreenWidth: "991",
        meanMenuContainer: ".mobile-menu",
        onePage: true,
        meanMenuClose: '<i class="pe-7s-close"></i>',
        meanMenuOpen: '<i class="pe-7s-menu"></i>',
        meanExpand: '<i class="pe-7s-angle-right"></i>',
        meanContract: '<i class="pe-7s-angle-down"></i>'      
      
    });
    
    /* slider activation */
    $('.slider_area').owlCarousel({
        animateOut: 'fadeOut',
        autoplay: true,loop: true,
        nav: true,
        autoplay: false,
        autoplayTimeout: 8000,
        items: 1,
        dots:true,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
    });
    
    
      /* categorie active two activation */
    $('.categorie_active_two').owlCarousel({
        autoplay: true,
		loop: true,
        nav: true,autoplay: false,
        autoplayTimeout: 8000,
        items: 7,
        dots:false,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
        responsiveClass:true,
		responsive:{
				0:{
				items:1,
			},
            480:{
				items:2,
			},
            768:{
				items:4,
			},
            992:{
				items:5,
			},
            1200:{
				items:6,
			},
            1600:{
				items:7,
			},
		  
        }
    });
    
    
      /* countdown produtc activation */
    var dealSlider = $('.countdown_produtc_active');    
    dealSlider.owlCarousel({
        autoplay: true,
		loop: true,
        nav: true,autoplay: false,
        autoplayTimeout: 8000,
        items: 2,
        dots:false,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
        responsiveClass:true,
		responsive:{
			0:{
				items:1,
			},
            576:{
				items:1,
			},
            768:{
				items:1,
			},
            992:{
				items:2,
			},
		  
        }
    });
    
    function dealSliderClasses() {
        dealSlider.each(function() {
            var total = $(this).find('.owl-item.active').length;
            $(this).find('.owl-item').removeClass('firstactiveitem');
            $(this).find('.owl-item').removeClass('lastactiveitem');
            $(this).find('.owl-item.active').each(function(index) {
                if (index === 0) {
                    $(this).addClass('firstactiveitem')
                }
                if (index === total - 1 && total > 1) {
                    $(this).addClass('lastactiveitem')
                }
            })
        })
    }
    dealSliderClasses();
    dealSlider.on('translated.owl.carousel', function(event) {
        dealSliderClasses()
    });         
    
    
    
     /* product four activation */
    $('.product_active_four').owlCarousel({
        autoplay: true,
		loop: true,
        nav: true,autoplay: false,
        autoplayTimeout: 8000,
        items: 6,
        dots:false,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
        responsiveClass:true,
		responsive:{
				0:{
				items:1,
			},
            576:{
				items:2,
			},
            992:{
				items:3,
			},
            1200:{
				items:4,
			},
            1200:{
				items:4,
			},
            1700:{
				items:5,
			},
            1900:{
				items:6,
			},
		  
        }
    });
    
      /* consoles four product activation */
    $('.consoles_active_four').owlCarousel({
        autoplay: true,
		loop: true,
        nav: true,autoplay: false,
        autoplayTimeout: 8000,
        items: 5,
        dots:false,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
        responsiveClass:true,
		responsive:{
			0:{
				items:1,
			},
            550:{
				items:2,
			},
            1200:{
				items:3,
			},
            1600:{
				items:4,
			},
            1800:{
				items:5,
			},
		  
        }
    });

     /* blog activation */
    $('.blog_active').owlCarousel({
        autoplay: true,
		loop: true,
        nav: true,autoplay: false,
        autoplayTimeout: 8000,
        items: 3,
        dots:false,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
        responsiveClass:true,
		responsive:{
				0:{
				items:1,
			},
            576:{
				items:2,
			},
            992:{
				items:3,
			},
		  
        }
    });
    
    
      /* blog active activation */
    $('.blog_thumb_active').owlCarousel({
        autoplay: true,
		loop: true,
        nav: true,autoplay: false,
        autoplayTimeout: 8000,
        items: 1,
        dots:false,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
    });
    
    
    
      /* blog active activation */
    $('.product_gallery_active').owlCarousel({
        autoplay: true,
		loop: true,
        nav: true,
        autoplay: false,autoplayTimeout: 8000,
        items: 4,
        dots:false,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
        responsiveClass:true,
		responsive:{
				0:{
				items:1,
			},
            576:{
				items:2,
			},
            992:{
				items:3,
			},
            1200:{
				items:4,
			},


		  }
    });
    
    
       /* product navactive activation */
    $('.product_navactive').owlCarousel({
        autoplay: true,
		loop: true,
        nav: false,
        autoplay: false,
        autoplayTimeout: 8000,
        items: 3,dots:true,
        responsiveClass:true,
		responsive:{
				0:{
				items:1,
			},
            250:{
				items:2,
			},
            480:{
				items:3,
			},
		  
        }
    });

    $('.modal').on('shown.bs.modal', function (e) {
        $('.product_navactive').resize();
    })

    $('.product_navactive a').on('click',function(e){
      e.preventDefault();

      var $href = $(this).attr('href');

      $('.product_navactive a').removeClass('active');
      $(this).addClass('active');

      $('.product-details-large .tab-pane').removeClass('active show');
      $('.product-details-large '+ $href ).addClass('active show');

    })
    
    
    //tooltip
    $('[data-toggle="tooltip"]').tooltip();
    $('.product_action a, .product_action button').tooltip({
            animated: 'fade',
            placement: 'top',
            container: 'body'
    });

    
    
    // Newsletter Popup
    
    function newsLetterPopup(){
        $('.newsletter_popup').css({"opacity": "1", "visibility": "visible"});
        $('.popup_close').on('click', function(){
          $(".newsletter_popup").fadeOut(200);
        })    
    }
    newsLetterPopup();
 
      
    
  });

})(jQuery);